import React from 'react';
import { Link } from 'react-router-dom';
import '../Concession/concession.css';
import './gates.css';
import GateIcon from './components/GateIcon';
import { queueColor } from './gatesMetrics';

export default function GatesCard({ locationData, data }) {
  const name = locationData.name;
  const gates = locationData.gates || [];
  const hasData = data != null;
  const fmt = (n) => (n || 0).toLocaleString();
  const entrances = hasData ? fmt(data.totalEntrances) : '—';
  const exits = hasData ? fmt(data.totalExits) : '—';
  // Both numbers share one size, set by the longer one
  const chars = Math.max(entrances.length, exits.length);

  // Live queue per gate. Only gates with queue sensors get a reading; the rest show a dash.
  const gateQueue = (gate) => {
    const hasSensors = !!gate.multiSensor?.queue_time || (gate.queueIds || []).length > 0;
    const reading = data?.gateQueueTimes?.[gate.gateId];
    if (!hasData || !hasSensors || !reading) return null;
    return Math.round(reading.queueTime || 0);
  };

  // Gates stay in config order so each one keeps its place between refreshes
  const tiles = gates.map((gate) => ({
    gate,
    label: gate.label || `Gate ${gate.gateId}`,
    queue: gateQueue(gate),
  }));

  return (
    <Link
      to={`../locations/gates`}
      state={{
        id: locationData.id,
        currentLocation: locationData,
      }}
      className="cx-card gx-card-wide"
      aria-label={name}
    >
      {/* Top: the day's totals across every gate. The location name is already the section title. */}
      <div className="gx-card-main">
        <div className="cx-card-metric" style={{ '--gx-chars': chars }}>
          <div className="gx-card-split">
            <div className="gx-card-stat">
              <div className="cx-metric-label">Total entrances</div>
              <div className={`gx-card-value${hasData ? '' : ' gx-card-empty'}`}>{entrances}</div>
            </div>
            <div className="gx-card-divider" aria-hidden="true" />
            <div className="gx-card-stat">
              <div className="cx-metric-label">Total exits</div>
              <div className={`gx-card-value${hasData ? '' : ' gx-card-empty'}`}>{exits}</div>
            </div>
          </div>
        </div>
      </div>

      {/* Below: a tile per gate (image, name, queue), two columns that grow taller.
          The coloured queue number makes the gate that needs attention easy to spot. */}
      {gates.length > 0 && (
        <div className="gx-gates">
          <div className="gx-tiles">
            {tiles.map(({ gate, label, queue }) => {
              const color = queue == null ? undefined : queueColor(queue);
              return (
                <div
                  className="gx-tile"
                  key={gate.gateId}
                  title={queue == null ? `${label}: no queue reading` : `${label}: ${queue} min queue`}
                >
                  <GateIcon imageURL={gate.imageURL} label={label} />
                  <span className="gx-tile-name">{label}</span>
                  {queue == null ? (
                    <span className="gx-tile-queue gx-card-empty">—</span>
                  ) : (
                    <span className="gx-tile-queue" style={{ color }}>
                      {queue}
                      <span className="gx-tile-unit">min</span>
                    </span>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </Link>
  );
}
